import { RenderText } from '@contentful/rich-text-react-renderer'
import { ReactNode } from 'react'
import { linkShortcode } from 'components/vendor/Contentful/richText/ShortcodeManager/elements/link'
import { embedShortcodes } from 'components/vendor/Contentful/richText/ShortcodeManager/elements/even-embed'
import { buttonShortcode } from 'components/vendor/Contentful/richText/ShortcodeManager/elements/button'
import { crossSellShortcode } from 'components/vendor/Contentful/richText/ShortcodeManager/elements/cross-sell'
import { bbmEmbedWidget } from 'components/vendor/Contentful/richText/ShortcodeManager/elements/bbm-embed'
import Logger from 'services/Logger'

export type ShortcodeFn = (name: string, attrs: Record<string, string>) => ReactNode
const embedCodes = embedShortcodes()
const shortcodes: Record<string, ShortcodeFn> = {
	link: linkShortcode,
	button: buttonShortcode,
	bbmEmbed: bbmEmbedWidget,
	'basic-xsell': crossSellShortcode,
	...embedCodes
}

const parseAttributes = (name: string, values: string) => {
	const attrs: Record<string, string> = {}
	const splitted = values.split(/(\s*([a-z0-9_-]+):\s*)/gim)
	attrs[name] = splitted?.shift()?.trim() || ''
	for (let i = 0; i < splitted.length; i += 3) {
		attrs[splitted[i + 1].trim()] = splitted[i + 2].trim()
	}
	return attrs
}

const matcher = /(?=[^\]])\(([a-zA-Z0-9_-]+):(.*?)\)/

const removeInvisibleChars = (text = '') => text.replace(/[\n\/\s](<[^>]>)/, '')

export const replaceShortcode: RenderText = (text: string) => {
	const regexToMatch = new RegExp(matcher, 'g')
	const match = regexToMatch.exec(text)
	if (match === null) return text
	const [raw, name, attributes] = match
	if (name && shortcodes[name] && match?.index != undefined) {
		const pre = text.slice(0, match.index)
		const post = text.slice(match.index + raw?.length)
		const attrs = parseAttributes(name, attributes)
		try {
			const widget = shortcodes[name](name, attrs)
			if (removeInvisibleChars(pre).length === 0 && removeInvisibleChars(pre).length == 0) return widget
			if (removeInvisibleChars(pre) === removeInvisibleChars(post)) return widget
			return [pre, shortcodes[name](name, attrs), post]
		} catch (err) {
			Logger.error(err)
			return undefined
		}
	}
	return text
}
